import { createHash } from "crypto";

export const secret = import.meta.env.VITE_APP_SECRET;
export const apiKey = import.meta.env.VITE_APP_KEY;

export function unixSeconds() {
  return Math.floor(Date.now() / 1000).toString();
}

export function secureHashFor(timestamp) {
  return createHash("sha256")
    .update(`${apiKey}${secret}${timestamp}`)
    .digest("hex");
}

export function fileParams() {
  const timestamp = unixSeconds();
  return `?api-key=${apiKey}&timestamp=${timestamp}&secure-hash=${secureHashFor(timestamp)}`;
}
